export enum StorageKey {
    UserToken = "@Storage:ariel:UserToken",
    User="@Storage:ariel:User",
    RememberUser="@Storage:ariel:RemeberUser",
    Email="@Storage:ariel:Email"
}